export default __webpack_public_path__ + "9a3f1dbc5283fac4f11f13da019055c2.svg";